import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { UpdateCommodityErrorProps } from './types';
import { UpdateCommodityError } from '@bechtel/types';

const getErrorMessage = (error: UpdateCommodityErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case UpdateCommodityError.COMMODITY_ALREADY_APPROVED:
      return <Trans>Approved commodity details cannot be updated.</Trans>;
    case UpdateCommodityError.EDIT_WELD_DETAIL_ERRORED:
      return <Trans>Update commodity errored.</Trans>;
    case UpdateCommodityError.INVALID_COMMODITY_ID:
      return <Trans>Invalid commodity id provided.</Trans>;
    case UpdateCommodityError.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing required permission.</Trans>;
    case UpdateCommodityError.STENCILS_ARE_REQUIRED:
      return <Trans>Stencils are mandatory.</Trans>;
    case UpdateCommodityError.WELD_PROCEDUREID_REQUIRED:
      return <Trans>Weld procedure id is required.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const UpdateCommodityErrorModal: FC<UpdateCommodityErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '400px', height: '275px' }}>
      <ModalHeader title={t`Edit Weld Details Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
